import messages from './messages';

export const getTooltipMessages = (
  isFreeApartmentWithIntercom?: boolean,
  isFreeApartmentWithAnsweringUnit?: boolean
) => {
  if (isFreeApartmentWithIntercom) {
    return {
      description: messages.FreeWithIntercomApartmentModelPopupText,
      title: messages.FreeWithIntercomApartmentModelPopupTitle,
    };
  } else if (isFreeApartmentWithAnsweringUnit) {
    return {
      description: messages.ApartmentFreeAnsweringUnitTooltipText,
      title: messages.ApartmentFreeAnsweringUnitTooltipHeader,
    };
  } else {
    return {
      description: messages.apartmentFreeTooltipText,
      title: messages.apartmentFreeTooltipHeader,
    };
  }
};
